/* eslint-disable*/

const getProp = prop =>
  getComputedStyle(document.documentElement, null).getPropertyValue(prop);

const sleep = (ms = 1000) => new Promise(res => setTimeout(res, ms));

const noop = () => {};

const makeId = _ =>
  Math.random()
    .toString(36)
    .substring(2, 15);

function cbToCb(cb) {
  return typeof cb === 'function' ? cb() : noop;
}

function clamp(num, min, max) {
  return num <= min ? min : num >= max ? max : num;
}

const roundTo = (n, precision) =>
  Math.round(n * 10 ** precision) / 10 ** precision;

async function measure(el) {
  if (!el.current) return;
  const rect = el.current.getBoundingClientRect();
  return new Promise(resolveIt => resolveIt(rect));
}

async function calculateAspectRatioFit(targetImage, maxWidth, maxHeight) {
  let { width, height } = targetImage;
  let ratio = Math.min(maxWidth / width, maxHeight / height);
  return new Promise(resolveIt =>
    resolveIt({
      ratio,
      width: roundTo(width * ratio, 0),
      height: roundTo(height * ratio, 0),
      targetImage,
    }),
  );
}

async function calculateAnimation(imageRef, frame, breakpoint) {
  let w = window;
  let d = document;
  let scrollTop = w.scrollY;
  let scrollLeft = w.scrollX;
  let viewportWidth = w.innerWidth || d.documentElement.clientWidth || 0;
  let viewportHeight = w.innerHeight || d.documentElement.clientHeight || 0;
  let targetImage = await measure(imageRef);
  let { ratio } = await calculateAspectRatioFit(
    targetImage,
    viewportWidth,
    viewportHeight,
  );
  let viewportX = viewportWidth / 2;
  let viewportY = scrollTop + viewportHeight / 2;
  let imageCenterX = targetImage.left + scrollLeft + targetImage.width / 2;
  let imageCenterY = targetImage.top + scrollTop + targetImage.height / 2;
  let translateX = roundTo(viewportX - imageCenterX, 0);
  let translateY = roundTo(viewportY - imageCenterY, 0);
  let factor =
    viewportHeight < breakpoint || viewportWidth < breakpoint
      ? 1
      : clamp(roundTo(clamp(roundTo(ratio, 2), 1, 5) - frame, 2), 1, 5);
  return new Promise(resolveIt =>
    resolveIt({ factor, translateX, translateY }),
  );
}

let createCache = () => {
  let cache = {};

  let has = key => key in cache;

  let get = key => {
    if (!has(key)) {
      return null;
    }
    return cache[key];
  };

  let set = (key, value) => (cache[key] = value);
  let clear = () => {
    cache = {};
  };

  return { has, get, set, clear };
};

let imageCache = createCache();

export default {
  makeId,
  imageCache,
  noop,
  cbToCb,
  sleep,
  roundTo,
  calculateAnimation,
  getProp,
};
